import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import GlobalStyles from './components/GlobalStyles';
import './mixins/chartjs';
import theme from './theme';
import routes from './routes';
import authroutes from './auth_routes';

const AppContent = () => {
  const auth = useAuth();
  const routing = useRoutes(routes);
  const authrouting = useRoutes(authroutes);

  // Check authentication status
  const isAuthenticated = auth.token && auth.isAuthenticated;

  return (
    <>
      {isAuthenticated ? routing : authrouting}
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
